import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const wsUrl = (token) => {
  const base = BACKEND_URL.replace(/^http/, "ws");
  return `${base}/api/ws/chat?token=${encodeURIComponent(token)}`;
};
